import BackTop from './back-top';

export default BackTop;
